import IAF from '@/pages/Iaf/Index.vue'

export default [
  {
    path: '/iaf',
    component: IAF
  }
]
